import React, { useState, useEffect } from "react"
import SearchResult from "../../../templates/search-result-template"
import { SearchTitle, PropertySearchURL, hasMyaccount } from "../../../common/constant"
import { UserObjectStoreProvider, getUserobjectData, isAuthenticated, doRedirect, storeData } from "@starberry/myaccount-website-utils";
import { navigate } from "@reach/router"

// markup
const SearchResultComp = (props) => {
  var location = typeof window !== "undefined" && window.location;
  // For myaccount
  useEffect(() => {

    //console.log("authuser ==>", authuser)

    // if(!authuser){
    //     storeData('auth_return', location?.href)
    //     doRedirect(process.env.GATSBY_MYACCOUNT_URL)
    //     return false;
    // }

    if (authuser && hasMyaccount) {
      const getUserObjects = async () => {
          try {
              const userObjects = await getUserobjectData()
              setUserObjects(userObjects.data.data)
          } catch (e) {
              console.log("e:", e)
          }
      }
      getUserObjects()
    }
  }, [])

  const [userObjects, setUserObjects] = useState({});
  const authuser = isAuthenticated()


  return (
    <SearchResult 
      title={SearchTitle.residential.newhomes} 
      department={"residential"} 
      search_type={"newhomes"} 
      status={['For Sale', 'Sale Agreed', 'Sold']} 
      path={PropertySearchURL["residential"]["newhomes"]}
      location={props.location}
      userObjects={userObjects}
      new_homes={true}
    />
  )
}

const PropertNewhomesForSale = (props) => {
  return(
      <UserObjectStoreProvider>
          <SearchResultComp {...props} />
      </UserObjectStoreProvider>
  )
}

export default PropertNewhomesForSale